// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-trips-trip-notification-page-module__root--FemQa {
  background-color: #7a8794;
  padding: 10px 10px 20px 10px;
}

.src-js-trips-trip-notification-page-module__rowGap--OqdU1 {
  margin-bottom: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/js/trips/trip-notification-page.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".root {\n  background-color: #7a8794;\n  padding: 10px 10px 20px 10px;\n}\n\n.rowGap {\n  margin-bottom: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `src-js-trips-trip-notification-page-module__root--FemQa`,
	"rowGap": `src-js-trips-trip-notification-page-module__rowGap--OqdU1`
};
export default ___CSS_LOADER_EXPORT___;
